<template>
  <div>
    <label
      :for="`field-${field.id}-displayCondition`"
      class="block text-sm font-medium text-gray-700"
    >
      {{ $t("fields.conditions") }}
    </label>
    <div class="flex">
      <div>
        <select
          :id="`field-${field.id}-displayCondition`"
          :name="`field-${field.id}-displayCondition`"
          class="mt-1 form-select transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="displayCondition"
        >
          <option value="">{{ $t("fields.always_show") }}</option>
          <option value="show">{{ $t("fields.show_if") }}</option>
          <option value="hide">{{ $t("fields.hide_if") }}</option>
        </select>
      </div>
      <div v-if="displayCondition !== ''">
        <select
          :id="`field-${field.id}-conditional-a`"
          :name="`field-${field.id}-conditional-a`"
          class="ml-1 mt-1 w-40 form-select transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="a"
        >
          <option value="">-------</option>
          <option
            v-for="(formfield, i) in fields.filter(
              (field) => field.element == 'field',
            )"
            v-bind:key="i"
            :value="formfield.id"
          >
            {{ formfield.label }}
          </option>
        </select>
        <select
          :id="`field-${field.id}-conditional-operator`"
          :name="`field-${field.id}-conditional-operator`"
          class="ml-1 mt-1 form-select transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="operator"
        >
          <option value="==">{{ $t("fields.equal_to") }}</option>
          <option value="!=">{{ $t("fields.not_equal_to") }}</option>
          <option value=">">{{ $t("fields.greater_than") }}</option>
          <option value="<">{{ $t("fields.smaller_than") }}</option>
        </select>
        <input
          :name="`field-${field.id}-conditional-b`"
          v-if="fieldOfA && !['dropdown', 'radio'].includes(fieldOfA.type)"
          class="flex-1 form-input ml-1 mt-1 w-32 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="b"
        />
        <select
          v-if="fieldOfA && ['dropdown', 'radio'].includes(fieldOfA.type)"
          :name="`field-${field.id}-conditional-b`"
          class="ml-1 mt-1 form-select transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          v-model="b"
        >
          <option
            v-for="option in fieldOfA.options"
            v-bind:key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditionalField',
  props: {
    field: Object,
    fields: Array,
    value: Object,
  },
  data() {
    const displayCondition = this.value
      ? this.value.show
        ? 'show'
        : this.value.hide
          ? 'hide'
          : ''
      : '';
    const operator =
      displayCondition &&
      Object.keys(this.value[displayCondition].when).length > 0
        ? Object.keys(this.value[displayCondition].when)[0]
        : '==';

    return {
      displayCondition,
      a: displayCondition
        ? this.value[displayCondition].when[operator][0].var
        : null,
      operator,
      b: displayCondition ? this.value[displayCondition].when[operator][1] : '',
    };
  },
  computed: {
    jsonLogic() {
      if (this.displayCondition == '') {
        return {};
      }

      if (!this.a) {
        return {};
      }

      return {
        [this.displayCondition]: {
          when: {
            [this.operator]: [{ var: this.a }, this.b],
          },
        },
      };
    },
    fieldOfA() {
      if (!this.a) {
        return null;
      }

      const results = this.fields.filter((field) => field.id === this.a);
      if (results.length > 0) {
        return results[0];
      }

      return null;
    },
  },
  watch: {
    jsonLogic(value) {
      this.$emit('input', value);
    },
  },
};
</script>
